import { render } from "./analysis.vue?vue&type=template&id=2dd6d740&scoped=true"
import script from "./analysis.vue?vue&type=script&lang=js"
export * from "./analysis.vue?vue&type=script&lang=js"

import "./analysis.vue?vue&type=style&index=0&id=2dd6d740&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dd6d740"]])

export default __exports__